<template>
  <div class="level">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ $t("m.yz_span9") }}</p>
    </div>
    <div class="level_con">
      <list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="getData"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          style="background-color: #ffffff; padding:10px 15px; border-bottom: 1px solid #ebedf0;margin-bottom:8px;border-radius:6px;"
        >
          <div
            style="margin-bottom: 5px;display:flex;justify-content: space-between;align-items:center;font-size:14px;border-bottom:1px solid #eee;padding-bottom:10px;"
          >
            <div style="flex:1;font-weight:bold;">
              {{
                item.direction === "out"
                  ? $t("m.yz_span13")
                  : $t("m.yz_span14")
              }}
            </div>
            <div
              :style="{
                color: item.direction === 'out' ? '#FF4438' : '#07c160',
                fontSize: '15px',
                fontWeight: 'bold'
              }"
            >
              {{ item.direction === "out" ? "-" : "+" }}{{ item.amount }}
              {{
                item.field_text ||
                  (item.field === "usdt"
                    ? "USDT"
                    : item.field === "gmo"
                    ? "GMO余额"
                    : "余额")
              }}
            </div>
          </div>
          <div style="margin-bottom: 5px;font-size:12px;color:#666;margin-top:5px;">
            {{ $t("m.yz_span15") }}：{{ item.from_mobile }}
          </div>
          <div style="margin-bottom: 5px;font-size:12px;color:#666;">
            {{ $t("m.yz_span16") }}：{{ item.to_mobile }}
          </div>
          <div
            v-if="item.remark"
            style="margin-bottom: 5px;font-size:12px;color:#666;"
          >
            {{ $t("m.jf_span7") }}：{{ item.remark }}
          </div>
          <div style="color: #666; font-size: 12px;">
            {{ $t("m.tz_span5") }}：{{ createDate(item.created_at) }}
          </div>
        </div>
      </list>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import Icon from "vant/lib/icon";
import List from "vant/lib/list";
import "vant/lib/list/style";

export default {
  name: "YueZhuanLog",
  components: {
    Icon,
    List
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  computed: {
    createDate() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    getData() {
      request
        .get("/pay/transfer/log", { page: this.page }, { login: true })
        .then(res => {
          const rows = (res.data && res.data.data) || [];
          if (rows.length > 0) {
            this.list = this.list.concat(rows);
            this.page++;
          } else {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.jiangli_top p {
  text-align: center;
  line-height: 50px;
  font-size: 16px;
}
.level_con {
  padding: 20px 15px;
}
</style>
